import { merge, Stack, Text } from '@fluentui/react';
import React, { useMemo } from 'react';
import background from '../../../assets/background2.png';
import { useReglements } from '../../../contexts/reglementContext';
import { ResponsiveSize, useResponsiveSize } from '../../../contexts/responsiveContext';
import { useStades } from '../../../contexts/stadeContext';

const SummaryAppelsDeFonds = () => {

    const { responsiveSize } = useResponsiveSize();
    const { stades } = useStades();
    const { reglements } = useReglements();

    const currencyFormat = useMemo(() => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }), []);

    const montantAppele = useMemo(() => {
        return Math.max(...stades.map(stade => stade.montantTotalTTCFacture || 0), 0);
    }, [stades]);

    const montantEncaisse = useMemo(() => {
        return reglements.reduce((total, reglement) => total += reglement.montantTTCReglement, 0);
    }, [reglements]);

    const montantAppeleStr = useMemo(() => {
        let result = montantAppele;
        if (isNaN(result)) return "-";
        else return currencyFormat.format(result);
    }, [currencyFormat, montantAppele]);

    const montantEncaisseStr = useMemo(() => {
        let result = montantEncaisse;
        if (isNaN(result)) return "-";
        else return currencyFormat.format(result);
    }, [currencyFormat, montantEncaisse]);

    const montantDuStr = useMemo(() => {
        let result = montantAppele - montantEncaisse;
        if (-0.01 < result && result < 0) result = 0; // Dans certains cas la valeur retournée est -0,00 €
        if (isNaN(result)) return "-";
        else return currencyFormat.format(result);
    }, [currencyFormat, montantAppele, montantEncaisse]);

    const styles = useMemo(
        () => {
            let styles = {
                bloc: { root: { gap: 13 } },
                data: {
                    root: {
                        alignItems: "center",
                        background: "white",
                        display: "inline-flex",
                        fontSize: 16,
                        fontWeight: 600,
                        height: 37,
                        justifyContent: "center",
                        lineHeight: "19px",
                        paddingTop: 3,
                        width: 180,
                    },
                },
                label: {
                    root: {
                        color: "white",
                        fontSize: 15,
                        fontWeight: 700,
                        lineHeight: "18px",
                        textTransform: "uppercase",
                    },
                },
                outer: {
                    root: {
                        alignItems: "center",
                        backgroundImage: `url(${background})`,
                        backgroundSize: "cover",
                        boxShadow: "inset 300px 0px 200px rgba(0, 0, 0, 0.5)",
                        flexDirection: "column",
                        gap: 30,
                        height: 300,
                        justifyContent: "center",
                        marginBottom: 30,
                        marginLeft: -36,
                        marginRight: -36,
                        paddingLeft: 60,
                        paddingRight: 60
                    }
                },
            };

            if (responsiveSize >= ResponsiveSize.medium)
                styles = merge(
                    styles,
                    {
                        outer: {
                            root: {
                                flexDirection: "row",
                                height: 180,
                                marginLeft: "unset",
                                marginRight: "unset",
                            }
                        },
                    }
                );

            return styles;
        },
        [responsiveSize]
    );

    return <Stack styles={styles.outer}>

        <Stack styles={styles.bloc}>
            <Text styles={styles.label}>Montant appelé&nbsp;:&nbsp;</Text>
            <Text styles={styles.data}>{montantAppeleStr}</Text>
        </Stack>

        <Stack styles={styles.bloc}>
            <Text styles={styles.label}>Montant encaissé&nbsp;:&nbsp;</Text>
            <Text styles={styles.data}>{montantEncaisseStr}</Text>
        </Stack>

        <Stack styles={styles.bloc}>
            <Text styles={styles.label}>Montant dû&nbsp;:&nbsp;</Text>
            <Text styles={styles.data}>{montantDuStr}</Text>
        </Stack>

    </Stack>;

};

export default SummaryAppelsDeFonds;